var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import PropTypes from 'prop-types';
import { createXScale, createYScale } from '../../utils/scale-helpers';
import GriffPropTypes, { seriesPropType, scalerFactoryFunc } from '../../utils/proptypes';
import ScalerContext from '../../context/Scaler';
import Line from '../Line';
import AxisDisplayMode from '../LineChart/AxisDisplayMode';
import Axes from '../../utils/Axes';

var LineCollection = function LineCollection(props) {
  var domainsByItemId = props.domainsByItemId,
      subDomainsByItemId = props.subDomainsByItemId,
      series = props.series,
      width = props.width,
      height = props.height,
      xAxis = props.xAxis,
      yScalerFactory = props.yScalerFactory,
      pointWidth = props.pointWidth,
      scaleX = props.scaleX;

  if (!subDomainsByItemId) {
    return null;
  }

  var clipPath = 'clip-path-' + width + '-' + height + '-' + series.filter(function (s) {
    return !s.hidden;
  }).map(function (s) {
    return s.id + '-' + (s.collectionId || 0) + '-' + (s.yAxisDisplayMode || AxisDisplayMode.ALL).id;
  }).join('/');

  var yScaler = yScalerFactory || function (s, h) {
    return createYScale(Axes.y(subDomainsByItemId[s.collectionId || s.id]), h);
  };

  var lines = series.reduce(function (l, s) {
    if (s.hidden) {
      return l;
    }

    var id = s.id;
    var xScale = createXScale(scaleX ? xAxis(subDomainsByItemId[id]) : xAxis(domainsByItemId[id]), width);
    var yScale = yScaler(s, height);
    return [].concat(l, [React.createElement(Line, _extends({
      key: s.id
    }, s, {
      xAxisAccessor: xAxis === Axes.time ? s.timeAccessor : s.xAccessor,
      xScale: xScale,
      yScale: yScale,
      clipPath: clipPath,
      pointWidth: s.pointWidth || pointWidth
    }))]);
  }, []);
  return React.createElement('g', {
    width: width,
    height: height
  }, React.createElement('clipPath', {
    id: clipPath
  }, React.createElement('rect', {
    width: width,
    height: height,
    fill: 'none'
  })), lines);
};

LineCollection.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  xAxis: PropTypes.oneOf(Axes.HORIZONTAL),
  series: seriesPropType,
  pointWidth: PropTypes.number,
  scaleX: PropTypes.bool,
  // These are provided by Griff
  yScalerFactory: scalerFactoryFunc,
  domainsByItemId: GriffPropTypes.domainsByItemId.isRequired,
  subDomainsByItemId: GriffPropTypes.subDomainsByItemId.isRequired
} : {};
LineCollection.defaultProps = {
  series: [],
  pointWidth: 6,
  scaleX: true,
  xAxis: Axes.time,
  yScalerFactory: null
};
export default (function (props) {
  return React.createElement(ScalerContext.Consumer, null, function (_ref) {
    var domainsByItemId = _ref.domainsByItemId,
        subDomainsByItemId = _ref.subDomainsByItemId,
        series = _ref.series;
    return React.createElement(LineCollection, _extends({
      series: series
    }, props, {
      domainsByItemId: domainsByItemId,
      subDomainsByItemId: subDomainsByItemId
    }));
  });
});